module.exports = __webpack_public_path__ + "static/media/lillan.3b1a652e.jpeg";